// extracted by mini-css-extract-plugin
module.exports = {"top":"styles_top__W4bBs","form":"styles_form__IhQyl"};